import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarLinkCard } from 'volto-ministerio-publico-federal/components/UI/SidebarLinkCard';

export interface ConteudoRelacionadoRef {
  '@id'?: string;
  '@type'?: string;
  Title?: string;
}

export interface ConteudoRelacionadoItem {
  label?: string;
  href?: ConteudoRelacionadoRef[];
  external?: boolean;
}

export interface ConteudosRelacionadosData {
  items?: ConteudoRelacionadoItem[];
}

interface MpfConteudosRelacionadosBlockViewProps {
  data: ConteudosRelacionadosData;
  isEditMode?: boolean;
}

/**
 * Bloco de sidebar "Conteúdos Relacionados" (RF06): mesma linguagem visual
 * do bloco "Serviços em Destaque" (RF05, ver `SidebarLinkCard`), mas aqui o
 * rótulo é texto livre do editor e o destino aceita página interna OU URL
 * externa — diferente do `relatedItems` nativo do Plone, que só referencia
 * conteúdo interno via UID e sempre usa o título do objeto como rótulo.
 */
export const MpfConteudosRelacionadosBlockView: React.FC<
  MpfConteudosRelacionadosBlockViewProps
> = ({ data, isEditMode }) => {
  const items = (data?.items ?? [])
    .filter((item) => !!item.label && !!item.href?.[0]?.['@id'])
    .map((item) => ({
      key: item.href![0]['@id'] as string,
      href: item.href![0]['@id'] as string,
      label: item.label as string,
      openInNewTab: item.external,
    }));

  return (
    <SidebarLinkCard
      title="Conteúdos Relacionados"
      items={items}
      emptyMessage="Nenhum conteúdo relacionado adicionado. Inclua um item com rótulo e link."
      isEditMode={isEditMode}
    />
  );
};

export default withBlockExtensions(MpfConteudosRelacionadosBlockView);
